import ReconnectingWebSocket from 'reconnecting-websocket'

export default {
  ws: null,
  init: function (url,onmessage,onOpen) {
    if (this.ws != null) {
      return
    }
    this.ws = new ReconnectingWebSocket(url)
    if(onOpen){
      this.ws.addEventListener('open',onOpen)
    }

    this.ws.onmessage = onmessage
  },
  destory:function () {
    this.ws.close()
    this.ws = null
  }

}



// WEBPACK FOOTER //
// ./src/utils/websocket.js